import {updateShopSetting,queryShopSetting,changeOrg,storeList} from '../../api/shop'
import{getWarnStatus} from '../../api/insurance'
import {readAgree,confirmAgree} from '../../../SRM/api/common'
import {currentUser} from '../../api/settlement'  //当前登录人信息

import { getBase,getIndex } from '../../api/person'
import {querySpecialOrderSetting} from '../../api/setting'
const state = {
    storeList:[],
    initStore:true,//是否初始化店铺
    isHeadquarters:false,//是否是总部
    smartStore:false,
    cloneStoreCode:"",
    storeName:'',
    settleAudit:0,//入驻审核状态
    insuranceToolTip:false,//保险审核提示
    userInfo:{},//用户信息
    orgName: null,
    showReadAgree:false,
    defaultPage:[],
    specialOrderSetting:null,//非常规订单结算方式;true资金池结算，false业务人员自行结算

    //配置参数--目的是为了功能在某一时间段的显示隐藏
    showSecondarySettlementPrice:false,//二级结算价相关的显示和隐藏secondary-settlement-price-setting && /account/user-list
    
  }
  const actions = {
    queryShopSetting(context){//查询店铺属性
        queryShopSetting().then(res=>{
          console.log(res,'----shop.js');
          if(res.code==200){
            // this.smartStore = res.data.smartStore
            // this.storeName = res.data.storeName
            context.commit('setSmartStore',res.data.smartStore);
            context.commit('setCloneStoreCode',res.data.cloneStoreCode);
            context.commit('setStoreName',res.data.storeName);
            context.commit('setOrgName',res.data.orgName);
          }else{
            // this.$message.error(res&&res.message)
          }
        })
      },
    storeListFun(context,params){
        storeList({systemType:2}).then(res=>{
          console.log(res);
          if(res.code==200){
              let storeList = []
            storeList = res.data!=null?res.data:[]
            console.log('查询店铺列表',storeList);
            storeList.map(i=>{
              i.statusName = i.orgAuditStatus==10?'待审核':i.orgAuditStatus==20?'已驳回':(i.orgAuditStatus==40&&i.storeName==null&&i.roleId!=4)?'已通过,未初始化':''
            })
            context.commit('setStoreList',storeList);
            console.log(storeList[0]);
            if(storeList[0]){
              console.log(storeList[0].storeName==null?false:true,'jiekoubuieghiu---------------');
              // 审核状态
              if(storeList[0].roleId==4){
                context.commit('setInitStore',true);
              }else{
                if(storeList[0].orgType == 3 && storeList[0].orgLevel == -1){
                  context.commit('setInitStore',true);
                }else{

                  context.commit('setInitStore',(storeList[0].orgAuditStatus==40&&storeList[0].storeName==null)?false:true);
                }
              }

              //是否是总部的判断  isHeadquarters
              /**
               * orgType：门店类型（1:门店&企业机构 2:自由销售人 3:总部特许经营）
               * orgLevel:-1 总部,  1 分社,  2 总部直属门店,   3 分公司,   4 业务部门,   5 分社所属门店
               * */
              if(storeList[0].orgType==3&&storeList[0].orgLevel==-1){
                context.commit('setHeadquarters',true);
              }else{
                context.commit('setHeadquarters',false);
              }





            }
          }else{
           this.$message.error(res.message)
          }
        })
    },
    getUserInfo(context){
      getBase().then(res=>{
        if(res.code==200){
          context.commit('setUserInfo',res.data)
        }
      })
    },
    insuranceToolTip(context){
      getWarnStatus().then(res=>{
        if(res.code==200){
          context.commit('setInsuranceToolTip',res.data)
        }
      })
    },

    readAgree(context){
      readAgree({systemType:2}).then(res=>{
        context.commit('setShowReadAgree',res.data==0?true:false)
      })
    },
    confirmAgree(context){
      confirmAgree({systemType:2}).then(res=>{
        context.commit('setShowReadAgree',false)
      })
    },
    getIndex(context){
      getIndex(2).then(res=>{
        if(res.data){
          context.commit('setDefaultPage',res.data)
        }
      })
    },
    querySpecialOrderSetting(context){
      querySpecialOrderSetting().then(res=>{
        if(res.code==200){ 
          context.commit('orderSetting',res.data)
        }else{
          this.$message.error('业务规则信息获取失败')
        }
      })
    }


  }

  const mutations = { //改变状态
    orderSetting(state, evnt){
      state.specialOrderSetting = evnt.specialOrderSetting!=null?evnt.specialOrderSetting:null;//true资金池结算，false业务人员自行结算
      // state.needAdminConfirm = evnt.needAdminConfirm!=null?evnt.needAdminConfirm:null
      // state.weChatSail = evnt.weChatSail!=null?evnt.weChatSail:null
    },
    setHeadquarters(state, evnt) {
      state.isHeadquarters  = evnt
  },
    setSmartStore (state, evnt) {
        state.smartStore  = evnt
    },
    setCloneStoreCode (state, evnt) {
      state.cloneStoreCode  = evnt
    },
      setStoreName(state,evnt){
        state.storeName  = evnt
    },
    setOrgName(state,evnt){
        state.orgName  = evnt
    },
    setStoreList:function(state,evnt){
        state.storeList  = evnt
    },
    setDefaultUrl(state,e){
        state.indexUrl  = e
    },
    setSettleAudit(state,e){
      state.settleAudit = e
    },
    setUserInfo(state,e){
      state.userInfo = e
    },
    setInsuranceToolTip(state,e){
      state.insuranceToolTip = e;
      // state.insuranceToolTip = ["您的保险配置已审核通过，请前往进行相关运营设置（保险&赠送项目设置）","新增保险产品【xxx,xxx】可前往【保险&赠送项目设置】进行绑定替换操作"];

    },
    setInitStore(state,e){
      state.initStore = e
    },
    setShowReadAgree(state,e){
      state.showReadAgree = e
    },
    setDefaultPage(state,e){
      state.defaultPage = e
    }
  }

  const getters = {
    orgName: state => state.orgName
  }

  export default {
    state,
    getters,
    actions,
    mutations
  }



// WEBPACK FOOTER //
// ./src/TASMini/store/modules/shop.js